import React from "react";
import { Card, CardContent, CardMedia, Typography, Box } from "@mui/material";
import { LinkedIn, Email } from "@mui/icons-material";

const TeamMember = ({ name, role, image, bio, linkedin, email }) => {
  return (
    <Card
      sx={{
        maxWidth: 350,
        height: "100%",
        display: "flex",
        flexDirection: "column",
        borderRadius: 3,
        boxShadow: 4,
        overflow: "hidden",
      }}
    >
      <CardMedia
        component="img"
        image={image}
        alt={name}
        sx={{
          width: "100%",
          height: 260,
          objectFit: "cover",
        }}
      />
      <CardContent
        sx={{ flexGrow: 1, display: "flex", flexDirection: "column" }}
      >
        <Typography gutterBottom variant="h6" fontWeight={600}>
          {name}
        </Typography>
        <Typography variant="subtitle2" color="primary" gutterBottom>
          {role}
        </Typography>
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ flexGrow: 1, mb: 2 }}
        >
          {bio}
        </Typography>
        <Box sx={{ display: "flex", gap: 2, mt: "auto" }}>
          {linkedin && (
            <LinkedIn
              color="primary"
              onClick={() => window.open(linkedin, "_blank")}
              sx={{ cursor: "pointer", fontSize: 24 }}
            />
          )}
          {email && (
            <Email
              color="primary"
              onClick={() => window.open(`mailto:${email}`, "_blank")}
              sx={{ cursor: "pointer", fontSize: 24 }}
            />
          )}
        </Box>
      </CardContent>
    </Card>
  );
};

export default TeamMember;
